import Avatar from 'components/Avatar';
import { getNameInitials } from 'utils/formatters';

const CreditNoteStatusChanged = ({
  router,
  notification,
  markAsRead,
  children,
  className = '',
}) => {
  const { data, sender, message, title } = notification;

  const onClick = () => {
    markAsRead();
    router.push(`/clients/${data.agencyClientId}/billing/creditnotes`);
  };

  return (
    <div className={`grid grid-cols-8 gap-3 ${className}`} onClick={onClick}>
      <Avatar
        size="48px"
        imageSrc={sender?.avatar?.thumbnailUrl}
        initials={getNameInitials(sender?.firstName, sender?.lastName)}
      />
      <div className="col-span-6">
        <p className="text-grayscale-800 text-13 mb-0 leading-1.5">{`${data?.client} - ${title}`}</p>
        <p className="text-grayscale-900 text-base leading-1.5">{message} </p>

        <div className="text-13 text-grayscale-800 flex items-center">
          <span>Amount</span>
          <span className="mx-1 bg-success-light text-success-dark py-0.5 px-2 rounded-xl">
            {`$ ${data.amount}`}
          </span>
        </div>
      </div>

      {children}
    </div>
  );
};

export default CreditNoteStatusChanged;
